const FinishScreen = ({ points, maxPossiblePoints,highscore,dispatch }) => {
  const percentage = (points / maxPossiblePoints) * 100;
  return (
    <>
      <p className={"result"}>
        You scored <strong>{points}</strong> out of {maxPossiblePoints} (
        {Math.ceil(percentage)})
      </p>
      <p className={"highscore"}>(highscore: {highscore} points)</p>
      <button className={"btn btn-ui"} onClick={() => dispatch({ type: "restart" })}>Restart Quiz</button>
    </>
  );
};

export default FinishScreen;
